import React from 'react'
import { Box, Grid, Paper } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const SkeletonPage = () => {
  return (
    <Grid container spacing={3}>
      {/* Tabs */}
      <Grid item xs={12}>
        <Box display="flex" gridGap={8}>
          {[120, 160, 140].map((width, i) => (
            <Skeleton key={i} variant="rect" width={width} height={36} />
          ))}
        </Box>
      </Grid>

      {/* Cards de questão */}
      {[1, 2, 3].map((i) => (
        <Grid item xs={12} key={i}>
          <Paper component={Box} p={2}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
              mb={1}
            >
              <Box flex={1}>
                <Skeleton variant="text" width="50%" height={28} />
                <Skeleton variant="text" width="80%" height={20} />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                gridGap={4}
                ml={2}
              >
                <Skeleton variant="rect" width={90} height={22} />
                <Skeleton variant="text" width={140} height={16} />
                <Skeleton variant="text" width={120} height={16} />
              </Box>
            </Box>

            <Box mt={2}>
              <Skeleton variant="text" width={80} height={20} />
              {[1, 2, 3].map((j) => (
                <Box key={j} display="flex" alignItems="center" mt={0.5}>
                  <Skeleton variant="circle" width={20} height={20} />
                  <Box ml={1}>
                    <Skeleton variant="text" width={100} height={18} />
                  </Box>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  )
}

export default SkeletonPage
